import React from 'react'
// hooks
import { formatDateValue, useDatePicker } from 'hooks/useDatePicker'
// components
import { DateTimePicker, DateTimePickerProps } from '@mui/x-date-pickers/DateTimePicker'

export interface CustomDateTimePickerProps extends Omit<DateTimePickerProps<any>, 'onChange' | 'label'> {
  error?: boolean
  label?: string
  onChange: (value: string) => void
  required?: boolean
  dateFormat?: string
}

const DateTimePickerComponent: React.FC<CustomDateTimePickerProps> = ({
  value,
  label,
  error,
  minDate,
  maxDate,
  required,
  onChange,
  dateFormat,
  ...rest
}) => {
  const { props } = useDatePicker({
    value,
    label,
    error,
    required,
    onChange
  })

  return (
    <DateTimePicker
      {...rest}
      {...props}
      ampm={dateFormat?.toLowerCase().includes('a') || false}
      minDate={formatDateValue(minDate)}
      maxDate={formatDateValue(maxDate)}
      format={dateFormat || 'DD MM YYYY HH:mm'}
    />
  )
}

export default DateTimePickerComponent
